import React, { Component } from 'react';
import './Header.css'

class Header extends Component {
    render() {
        return (
            <section class="category_banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h1>Custom Research</h1>
                            <p>Our polygonal approach streamlines any research &amp; addresses our client's specific needs. We provide customized, actionable market insights to clients across geocentric &amp; customer-centric markets.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/consulting/CustomResearch/Header/Header.js